import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { resolveSupportedLang } from '../../i18n'
import { getStoredAuth } from '../../api/httpClient'
import { storeRequestPrefill } from '../../utils/requestPrefillStorage'
import type { PvKostenRechnerValues } from './PvKostenRechnerWidget'

/**
 * Shared CTA behaviour for PvKostenRechnerWidget's "Jetzt kostenlosen Auftrag erstellen" button
 * (tasks/new-things/preis-durchschnittsrechner/04-cta-prefill-deep-link.md) - used both on the
 * main landing page (03) and the dedicated /pv-kostenrechner SEO page (05). Kept separate from the
 * generic onSelectCustomer used by every other CTA on the site instead of widening that shared
 * prop: many call sites bind onSelectCustomer directly as a DOM onClick handler, so giving it an
 * optional argument there would silently leak the click's MouseEvent in as "prefill".
 */
export function usePriceCalculatorCta(onSelectCustomer: () => void) {
  const navigate = useNavigate()
  const { i18n } = useTranslation()
  const lang = resolveSupportedLang(i18n.resolvedLanguage)

  return function handleCalculatorRequestOffer(values: PvKostenRechnerValues) {
    if (getStoredAuth()?.role === 'CUSTOMER') {
      // Bereits eingeloggt: direkt in den Auftrags-Wizard statt über die Registrierung (Fall
      // "eingeloggt" im Task).
      navigate(`/${lang}/customer/requests`, { state: { autoStart: true, prefill: values } })
      return
    }
    storeRequestPrefill(values)
    onSelectCustomer()
  }
}
